import(/* webpackMode: "eager" */ "/app/node_modules/tippy.js/dist/tippy.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/tippy.js/themes/light.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@rainbow-me/rainbowkit/dist/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/app/src/app/(bridge)/BridgeClient.tsx");
